import { auth } from '../firebase'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3099'

export async function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const user = auth.currentUser
  if (!user) throw new Error('Not authenticated')

  const token = await user.getIdToken()
  const headers = new Headers(options.headers)
  headers.set('Authorization', `Bearer ${token}`)

  const fullUrl = url.startsWith('/') ? `${API_URL}${url}` : url

  return fetch(fullUrl, { ...options, headers })
}
